import BaseExtension from './base';

import createElement from '../utils/createElement';

import popover from './helpers/popover';

import createSvg, { NEXT_TRACK } from '../svgs';

const CN = 'rmp-ext-next-frame';

export default class NextFrameExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options);
      this.logger.debug('nextframe:extension:creating');

      this.render();
      this.addEvent(this.$el, 'click', this.nextframe.bind(this));

      this.logger.debug('nextframe:extension:created');
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$el = createElement('button', { type: 'button', class: CN });
      setTimeout(() => popover(this, { $button: this.$el, text: this.$t('nextframe') }) );
      createSvg(this.$el, NEXT_TRACK);
   }

   nextframe() {
      this.player.nextFrame();
   }

   getElement() {
      return this.$el;
   }

   destroy() {
      super.destroy();

      const parent = this.$el.parentNode;
      parent.removeChild(this.$el);
      this.$el = null;
   }
}
